import { getSharedConfig } from "../../createSharedConfig"
import { RackOptions } from "@/js/pages/product/rackbuilder/RackTypes"
import { findBundleProduct, getAccessoryQuantity } from "@/js/pages/product/rackbuilder/utils/product-lookup"
import { getCommonAccessorySelections, getJCupSelection, getPlateStorageSelection, getBandPegSelection } from "@/js/pages/product/rackbuilder/utils/selection-utils"
import { IRogue, BuyRequest } from "@/js/services/RogueTypes"

// Creates FM/FML-Twin
export function createTwinHRConfig(rogue: IRogue, buyRequest: BuyRequest): RackOptions {
  const sharedConfig = getSharedConfig(rogue, buyRequest)
  const functionalTrainer = findBundleProduct(rogue, buyRequest, 'functional trainer')
  const { trolleySelection, lowRowSelection, latBarSelection } = getCommonAccessorySelections(rogue, buyRequest, sharedConfig.materials || {})

  return {
    ...sharedConfig,
    back            : '',
    front           : 'crossmember top 4',
    edition         : 'twin',
    safeties        : undefined,
    jcup            : getJCupSelection(rogue, buyRequest),
    halfRack        : true,
    depth           : '2',
    sixPost         : false,
    plateStorage    : getPlateStorageSelection(rogue, buyRequest),
    bandPegs        : getBandPegSelection(rogue, buyRequest),
    ftShrouds       : functionalTrainer?.attributes?.rig_or_wm === 'Yes',
    frontStabilizer : findBundleProduct(rogue, buyRequest, 'feet', true) !== undefined,
    spotterArms     : findBundleProduct(rogue, buyRequest, 'safeties', true) !== undefined
      ? 1
      : getAccessoryQuantity(rogue, buyRequest, 'spotter arms'),
    trolleySelection,
    latBarSelection,
    lowRowSelection,
  }
}
